/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Faq_Browser_QInputs */

const en_gc_resources_faq_browser_q = /** @type {(inputs: Gc_Resources_Faq_Browser_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use GridCraft online without installing it?`)
};

const zh_gc_resources_faq_browser_q = /** @type {(inputs: Gc_Resources_Faq_Browser_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不安装也能在线使用 GridCraft 吗？`)
};

/**
* | output |
* | --- |
* | "Can I use GridCraft online without installing it?" |
*
* @param {Gc_Resources_Faq_Browser_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_faq_browser_q = /** @type {((inputs?: Gc_Resources_Faq_Browser_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Faq_Browser_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_faq_browser_q(inputs)
	return zh_gc_resources_faq_browser_q(inputs)
});
export { gc_resources_faq_browser_q as "gc.resources.faq.browser.q" }